const fadeInOut = (duration = 0.2) => ({
  from: {
    opacity: 0,
    transition: {
      type: 'easeInOut',
      duration,
    },
  },
  to: {
    opacity: 1,
    transition: {
      type: 'easeInOut',
      duration,
    },
  },
});

export default fadeInOut;
